<template>
    <div class="minimap">
        <img :src="img">
        <div class="I1Btn" :style="{top:(y/2) + 'px',left:(x/2)+'px'}">X</div>
    </div>
</template> 

<script>
export default {
    name: "Minimap",
    props: ["img", "x", "y"]
}
</script>

<style scoped>
.minimap{
    width: 400px;
    height: 300px;
    position: relative;
}
.minimap img{
    width: 400px;
    height: 300px;
    object-fit: contain;
    background: green;
}
.I1Btn {
    position:absolute;
    width: 25px;
    height: 25px;
    background: black;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    vertical-align: middle;
    font-size: 1.3em;
}
</style>